import { Component } from '@angular/core';

export interface Blog {
  image: string;
  title: string;
  category: string;
  color: string;
  time: string;
}

@Component({
  standalone: false,
  selector: 'app-blog-grid',
  templateUrl: './blog-grid.component.html',
  styleUrl: './blog-grid.component.css'
})
export class BlogGridComponent {
  //Blogs
  posts: Blog[] = [
    {
      image: 'assets/images/blogs/post-01.jpg',
      title: 'Kobe Steel plant that supplied plane components being checked',
      category: 'News',
      color: 'purple-color',
      time: '7 hours ago'
    },
    {
      image: 'assets/images/blogs/post-02.jpg',
      title: 'They say that a picture is worth a thousand words',
      category: 'Events',
      color: 'pink-color',
      time: 'Yesterday'
    },
    {
      image: 'assets/images/blogs/post-03.jpg',
      title: 'NewsBike | NY News Satire, Parody and Spoof News',
      category: 'Blog',
      color: 'blue-color',
      time: 'December 21, 2024'
    },
    {
      image: 'assets/images/blogs/post-04.jpg',
      title: 'Kobe Steel plant that supplied plane components being checked',
      category: 'News',
      color: 'purple-color',
      time: '7 hours ago'
    },
    {
      image: 'assets/images/blogs/post-05.jpg',
      title: 'They say that a picture is worth a thousand words',
      category: 'Events',
      color: 'pink-color',
      time: 'Yesterday'
    },
    {
      image: 'assets/images/blogs/post-06.jpg',
      title: 'NewsBike | NY News Satire, Parody and Spoof News',
      category: 'Blog',
      color: 'blue-color',
      time: 'December 21, 2024'
    },
    {
      image: 'assets/images/blogs/post-07.jpg',
      title: 'Kobe Steel plant that supplied plane components being checked',
      category: 'News',
      color: 'purple-color',
      time: '7 hours ago'
    },
    {
      image: 'assets/images/blogs/post-08.jpg',
      title: 'They say that a picture is worth a thousand words',
      category: 'Events',
      color: 'pink-color',
      time: 'Yesterday'
    },
    {
      image: 'assets/images/blogs/post-09.jpg',
      title: 'NewsBike | NY News Satire, Parody and Spoof News',
      category: 'Blog',
      color: 'blue-color',
      time: 'December 21, 2024'
    }
  ];

  //Footer
  socialLinks = [
    { icon: 'bi-facebook', url: '/' },
    { icon: 'bi-twitter-x', url: '/' },
    { icon: 'bi-pinterest', url: '/' },
    { icon: 'bi-dribbble', url: '/' }
  ];

  quickLinks = [
    { name: 'About Us', url: '/about-us' },
    { name: 'Services', url: '/services' },
    { name: 'Portfolio', url: '/portfolio-one' },
    { name: 'Blogs', url: '/blog-grid' },
    { name: 'Contact Us', url: '/contact' }
  ];

  recentPosts = [
    {
      image: 'assets/images/blogs/post-img-sm.jpg',
      title: 'Ut venenatis, Commodo ligula',
      desc: 'Lorem ipsum dolor sit amet, adipiscing elit...'
    },
    {
      image: 'assets/images/blogs/post-img-sm-2.jpg',
      title: 'Ut venenatis, Commodo ligula',
      desc: 'Lorem ipsum dolor sit amet, adipiscing elit...'
    }
  ];
}
